import initializeCookieBanner from './js/banner.js'
import initializeHeader from './js/initialize-header.js'
import scrollToTop from './js/scroll-to-top.js'
initializeHeader()
scrollToTop()
initializeCookieBanner()
